import { createApp } from 'vue'
import Detail from '@/js/it-vacancies/vacancies/Detail'

createApp(Detail).mount('#vacancies-detail')
